import React from 'react'

const CardSuit = (props) => {
    const type = props.type
    return (
        <>
            {
                type === 'hearts' &&
                <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.0054 0.00112967C13.521 0.0682344 11.8157 2.53418 11.4373 4.77616C11.0589 2.53418 9.35365 0.0681897 5.86921 0.00112967C2.65658 -0.0606138 0 2.41065 0 6.92069C0 12.7103 6.54883 15.3847 11.027 19.7095C11.1829 19.8601 11.1462 19.8562 11.1462 19.8562C11.2198 19.9469 11.3256 19.9995 11.4368 19.9995C11.548 19.9995 11.6547 19.9469 11.7283 19.8562C11.7283 19.8562 11.6916 19.86 11.8476 19.7095C16.3258 15.3847 22.8746 12.7103 22.8746 6.92069C22.8746 2.41065 20.218 -0.0606138 17.0054 0.00112967Z" fill="#ffffff" />
                </svg>

            }

            {
                type === 'spades' &&
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.41014 0.249531C9.28623 0.110703 9.30775 0.123515 9.30775 0.123515C9.24436 0.0451952 9.15318 0 9.0574 0C8.96166 0 8.87084 0.0451952 8.80744 0.123515C8.80744 0.123515 8.82944 0.110703 8.70506 0.249531C5.6435 3.70363 0 5.66011 0 10.6321C0 10.8874 0.0112109 11.1536 0.034414 11.4304C0.281015 14.3494 2.3971 16.0054 4.68351 16.0054C5.98132 16.0054 7.21448 15.1403 8.03893 13.886C7.65217 16.3109 7.15604 19.0018 7.01674 19.3359C6.77921 19.905 7.06401 20 7.2062 20H10.909C11.0511 20 11.3355 19.905 11.0984 19.3359C10.9595 19.0018 10.4625 16.3109 10.0767 13.886C10.9007 15.1403 12.1338 16.0054 13.4317 16.0054C15.7185 16.0054 17.8341 14.3494 18.0812 11.4304C18.1043 11.1536 18.1151 10.8874 18.1151 10.6321C18.1152 5.66011 12.4717 3.70363 9.41014 0.249531Z" fill="#ffffff" />
                </svg>

            }

            {
                type === 'diamonds' &&
                <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.18301 0L0 10L7.18301 20L14.366 10L7.18301 0Z" fill="#ffffff" />
                </svg>

            }

            {
                type === 'clubs' &&
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.1009 7.15741C12.8535 7.15741 12.611 7.17862 12.3746 7.21686C12.9512 6.461 13.2949 5.51819 13.2949 4.49601C13.2949 2.01703 11.2779 0 8.79893 0C6.31964 0 4.30261 2.01703 4.30261 4.49601C4.30261 5.51815 4.64605 6.46096 5.22261 7.21686C4.9862 7.17866 4.74366 7.15741 4.49663 7.15741C2.01703 7.15741 0 9.17475 0 11.6534C0 14.133 2.01703 16.1494 4.49663 16.1494C5.8821 16.1494 7.12272 15.5188 7.94795 14.5297C7.80663 16.5066 7.49756 18.3925 6.91389 20H10.6833C10.0999 18.3925 9.79053 16.5066 9.64924 14.5297C10.4745 15.5188 11.7151 16.1494 13.1009 16.1494C15.5802 16.1494 17.5972 14.133 17.5972 11.6534C17.5972 9.17475 15.5801 7.15741 13.1009 7.15741Z" fill="#ffffff" />
                </svg>

            }
        </>
    )
}

export default CardSuit